import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@auth0/auth0-angular';
import { DataResolverService } from './services/data-resolver.service';
import { ErrorPagePage } from './error-page/error-page.page';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'legal',
    loadChildren: () =>
      import('./legal/legal.module').then((m) => m.LegalPageModule),
  },
  {
    path: 'tutorial',
    loadChildren: () =>
      import('./tutorial/tutorial.module').then((m) => m.TutorialPageModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'release-notes',
    loadChildren: () =>
      import('./release-notes/release-notes.module').then(
        (m) => m.ReleaseNotesPageModule,
      ),
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./support/support.module').then((m) => m.SupportPageModule),
  },
  {
    path: 'places',
    loadChildren: () =>
      import('./places/places.module').then((m) => m.PlacesPageModule),
    canActivate: [AuthGuard],
    resolve: { loaded: DataResolverService },
  },
  {
    path: 'maps',
    loadChildren: () =>
      import('./maps/maps.module').then((m) => m.MapsPageModule),
    canActivate: [AuthGuard],
    resolve: { loaded: DataResolverService },
  },
  {
    path: 'layouts',
    loadChildren: () =>
      import('./layouts/layouts.module').then((m) => m.LayoutsPageModule),
    canActivate: [AuthGuard],
    resolve: { loaded: DataResolverService },
  },
  {
    path: 'series',
    loadChildren: () =>
      import('./series/series.module').then((m) => m.SeriesPageModule),
    canActivate: [AuthGuard],
    resolve: { loaded: DataResolverService },
  },
  {
    path: 'upgrade',
    loadChildren: () =>
      import('./upgrade/upgrade.module').then((m) => m.UpgradePageModule),
    canActivate: [AuthGuard],
    resolve: { loaded: DataResolverService },
  },
  {
    path: '404',
    loadChildren: () =>
      import('./error-page/error-page.module').then(
        (m) => m.ErrorPagePageModule,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  { path: '**', component: ErrorPagePage },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      // enableTracing: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
